import { render, staticRenderFns } from "./20.vue?vue&type=template&id=f962c146&scoped=true&"
var script = {}
import style0 from "./20.vue?vue&type=style&index=0&id=f962c146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f962c146",
  null
  
)

export default component.exports